<template>
  <div v-if="!isEmpty" class="user-listing-detail min-height">
    <div
      class="
        Head-div
        p-3
        d-flex
        justify-content-between
        align-items-center
        border-bottom
      "
    >
      <h4 class="mb-0">Allied Details</h4>
      <div class="cursor" @click.stop="$emit('close')">
        <crossSVG />
      </div>
    </div>
    <CCol sm="12" class="px-0 inner-scroller">
      <CCol sm="12" class="user-profile-info border-bottom">
        <div class="media">
          <image-view
            :src="
              doctorInfo.userProfile.profile_image
                ? doctorInfo.userProfile.profile_image
                : '/img/avatars/default-user.png'
            "
          ></image-view>

          <div class="media-body pl-4">
            <div class="d-flex">
              <div>
                <h3 class="mt-0 font-weight-normal white-space">
                  Dr. {{ doctorInfo.userProfile.full_name }}
                </h3>
                <p class="mb-1 flex-wrap">
                  <span class="text-dark">Email :</span>
                  {{
                    doctorInfo.userProfile.email
                      ? doctorInfo.userProfile.email
                      : "&#8213;"
                  }}
                </p>
                <p class="mb-1">
                  <span class="text-dark">Gender :</span>
                  {{ doctorInfo.userProfile.gender }}
                </p>
                <p class="mb-1">
                  <span class="text-dark">Mobile :</span>
                  {{ doctorInfo.userProfile.mobile }}
                </p>
              </div>

              <!-- <div class="mt-1 ml-4">
                <h6>Roles</h6>
                <div class="d-flex flex-wrap">
                  <div v-for="(role, i) in doctorInfo.userProfile.completed_profiles" :key="i" 
                  class="pr-1">
                    <v-btn large class="mr-3 mb-2">{{ role }}</v-btn>
                  </div>
                </div>
              </div> -->
            </div>
          </div>

          <div>
            <div class="mt-2">
              <span class="font-weight-bold">Referral Code:</span>
              {{
                doctorInfo.userProfile &&
                doctorInfo.userProfile.reference_code &&
                doctorInfo.userProfile.reference_code.code
                  ? doctorInfo.userProfile.reference_code.code
                  : "&#8213;"
              }}
            </div>
          </div>
        </div>
      </CCol>
      <!-- .... end user-profile-info ... -->
      <CCol sm="12" class="px-0">
        <!-- ...... Personal Details...... -->
        <CCol sm="12" class="p-0">
          <CCol sm="12" class="pt-0 border-bottom">
            <h6 class="mb-0 text-dark">Personal Details</h6>
          </CCol>
          <CCol sm="12" class="border-bottom">
            <CRow>
              <CCol sm="6" md="2">
                <p class="text-dark mb-0">Date of birth :</p>
                <p>
                  {{
                    doctorInfo.userProfile.dob
                      ? dayJS(doctorInfo.userProfile.dob).format(
                          formats.date_format
                        )
                      : "&#8213;"
                  }}
                </p>
              </CCol>
              <CCol sm="6" md="1">
                <p class="text-dark mb-0">Age :</p>
                <p>
                  {{
                    doctorInfo.userProfile.age
                      ? doctorInfo.userProfile.age
                      : "&#8213;"
                  }}
                </p>
              </CCol>
              <CCol sm="6" md="2">
                <p class="text-dark mb-0">Blood Group :</p>
                <p>
                  {{
                    doctorInfo.userProfile.blood_group
                      ? doctorInfo.userProfile.blood_group
                      : "&#8213;"
                  }}
                </p>
              </CCol>
              <CCol sm="6" md="3">
                <p class="text-dark mb-0">Languages :</p>
                <p v-if="doctorInfo.userProfile.known_languages.length">
                  <span
                    v-for="(language, i) in doctorInfo.userProfile
                      .known_languages"
                    :key="i"
                    >{{ language }},</span
                  >
                </p>
                <p v-else>&#8213;</p>
              </CCol>
              <CCol
                @click="
                  doctorInfo.userProfile.national_identity_type
                    ? openModal(
                        doctorInfo.userProfile.national_identity_certificate,
                        doctorInfo.userProfile.national_identity_type
                      )
                    : null
                "
                sm="6"
                md="4"
              >
                <p class="text-dark mb-0">Identity Type :</p>
                <div class="d-flex align-items-center">
                  <p class="mb-0">
                    {{
                      doctorInfo.userProfile.national_identity_type
                        ? doctorInfo.userProfile.national_identity_type
                        : "&#8213;"
                    }}
                  </p>
                  <div
                    class="file-attachment d-flex align-items-center ml-4"
                    v-if="doctorInfo.userProfile.national_identity_certificate"
                  >
                    <fileSVG />
                    <p class="ml-2 mb-0 cursor">
                      {{
                        doctorInfo.userProfile.national_identity_certificate
                          ? doctorInfo.userProfile.national_identity_certificate
                              .split("/")
                              .pop()
                          : "&#8213;"
                      }}
                    </p>
                  </div>
                </div>
              </CCol>
            </CRow>
            <!-- ............ -->
            <CRow>
              <CCol sm="6" md="4">
                <p class="text-dark mb-0">
                  Relife member :
                </p>
                <p>
                  {{ doctorInfo.userProfile.is_relife_member ? "Yes" : "No" }}
                </p>
              </CCol>
              <CCol md="8" sm="6">
                <p class="text-dark mb-0">About:</p>
                <p>
                  {{
                    doctorInfo.userProfile.bio
                      ? doctorInfo.userProfile.bio
                      : "&#8213;"
                  }}
                </p>
              </CCol>
            </CRow>
            <!-- ............ -->
            <CRow>
              <CCol sm="12">
                <h6 class="mb-5 text-dark">Nominee Details</h6>
                <CCol sm="12">
                  <CRow>
                    <CCol sm="6" md="2" class="p-0">
                      <p class="text-dark mb-0">First Name :</p>
                      <p>
                        {{
                          doctorInfo.userProfile.nominee_first_name
                            ? doctorInfo.userProfile.nominee_first_name
                            : "&#8213;"
                        }}
                      </p>
                    </CCol>
                    <CCol sm="6" md="2" class="p-0">
                      <p class="text-dark mb-0">Last Name :</p>
                      <p>
                        {{
                          doctorInfo.userProfile.nominee_last_name
                            ? doctorInfo.userProfile.nominee_last_name
                            : "&#8213;"
                        }}
                      </p>
                    </CCol>
                    <CCol sm="6" md="2" class="p-0">
                      <p class="text-dark mb-0">Relationship :</p>
                      <p>
                        {{
                          doctorInfo.userProfile.nominee_relation
                            ? doctorInfo.userProfile.nominee_relation
                            : "&#8213;"
                        }}
                      </p>
                    </CCol>
                    <CCol sm="6" md="2" class="p-0">
                      <p class="text-dark mb-0">Mobile Number :</p>
                      <p>
                        {{
                          doctorInfo.userProfile.nominee_mobile
                            ? doctorInfo.userProfile.nominee_mobile
                            : "&#8213;"
                        }}
                      </p>
                    </CCol>
                    <CCol sm="6" md="2" class="p-0">
                      <p class="text-dark mb-0">Email :</p>
                      <p>
                        {{
                          doctorInfo.userProfile.nominee_email
                            ? doctorInfo.userProfile.nominee_email
                            : "&#8213;"
                        }}
                      </p>
                    </CCol>
                  </CRow>
                </CCol>
              </CCol>
            </CRow>
            <!-- <CRow>
              <CCol sm="12" v-if="doctorInfo.userProfile.additional_specialty.length">
                <h6 class="mb-5 text-dark">Additional Specialities:</h6>
                <CCol sm="12" >
                  <CRow>
                    <CCol sm="6" md="2" class="p-0" v-for="(speciality, i) in doctorInfo.userProfile.additional_specialty" :key="i">
                      <p class="text-dark mb-0">{{  speciality.specialty_type}}</p>
                    </CCol>

                  </CRow>
                </CCol>
              </CCol>
            </CRow> -->
          </CCol>
        </CCol>
        <!-- ...... end Personal Details...... -->
        <!-- ...... Doctor Residential Details...... -->
        <CCol sm="12" class="p-0">
          <CCol sm="12" class="border-bottom">
            <h6 class="mb-0 text-dark">Allied Residential Details</h6>
          </CCol>
          <!-- ............ -->
          <CCol sm="12" class="border-bottom">
            <CRow>
              <CCol sm="6" md="4">
                <p class="text-dark mb-0">Current address :</p>
                <p v-if="doctorInfo.userProfile.address.current_address">
                  {{
                    doctorInfo.userProfile.address.current_address
                      .address_line_two
                      ? doctorInfo.userProfile.address.current_address
                          .address_line_two
                      : "&#8213;"
                  }}
                </p>
                <p v-else>&#8213;</p>
              </CCol>
              <CCol sm="6" md="4">
                <p class="text-dark mb-0">More details :</p>
                <p v-if="doctorInfo.userProfile.address.current_address">
                  {{
                    doctorInfo.userProfile.address.current_address
                      .address_line_one
                      ? doctorInfo.userProfile.address.current_address
                          .address_line_one
                      : "&#8213;"
                  }}
                </p>
              </CCol>
              <CCol sm="6" md="4">
                <p class="text-dark mb-0">
                  Permanent address same as current address :
                </p>
                <p>
                  {{
                    doctorInfo.userProfile.address.is_same_as_current
                      ? "Yes"
                      : "No"
                  }}
                </p>
              </CCol>
            </CRow>
            <CRow>
              <CCol sm="6" md="4">
                <p class="text-dark mb-0">Permant address :</p>
                <p v-if="doctorInfo.userProfile.address.permanent_address">
                  {{
                    doctorInfo.userProfile.address.permanent_address
                      .address_line_two
                      ? doctorInfo.userProfile.address.permanent_address
                          .address_line_two
                      : "&#8213;"
                  }}
                </p>
                <p v-else>&#8213;</p>
              </CCol>
              <CCol sm="6" md="4">
                <p class="text-dark mb-0">More details :</p>
                <p v-if="doctorInfo.userProfile.address.permanent_address">
                  {{
                    doctorInfo.userProfile.address.permanent_address
                      .address_line_one
                      ? doctorInfo.userProfile.address.permanent_address
                          .address_line_one
                      : "&#8213;"
                  }}
                </p>
              </CCol>
            </CRow>
          </CCol>
        </CCol>
        <!-- ...... end Doctor Residential Details...... -->
        <!-- ..... Qualifications And Specialities ....... -->
        <CCol sm="12" class="p-0">
          <CCol sm="12" class="border-bottom">
            <h6 class="mb-0 text-dark">Qualifications And Specialities</h6>
          </CCol>
          <!-- ............ -->
          <CCol sm="12" class="border-bottom">
            <CRow>
              <!-- <CCol sm="6" md="2">
                <p class="text-dark mb-0">Branch of Medicine :</p>
                <p>
                  {{
                    doctorInfo.userProfile.branch_of_medicine
                    ? doctorInfo.userProfile.branch_of_medicine
                    : "&#8213;"
                  }}
                </p>
              </CCol> -->
              <CCol sm="6" md="2">
                <p class="text-dark mb-0">Professions :</p>
                <p
                  v-for="(specialities, i) in doctorInfo.doctor.data
                    .specialities"
                  :key="i"
                >
                  {{ specialities.specialty_type }}
                </p>
              </CCol>
              <CCol sm="6" md="2">
                <p class="text-dark mb-0">Registering state :</p>
                <p>
                  {{
                    doctorInfo.userProfile.allied.doc_certification_state
                      ? doctorInfo.userProfile.allied.doc_certification_state
                      : "&#8213;"
                  }}
                </p>
              </CCol>
              <CCol sm="6" md="3">
                <p class="text-dark mb-0">Registering council name :</p>
                <p>
                  {{
                    doctorInfo.userProfile.allied.registry_council_name
                      ? doctorInfo.userProfile.allied.registry_council_name
                      : "&#8213;"
                  }}
                </p>
              </CCol>
              <CCol sm="6" md="3">
                <p class="text-dark mb-0">Registering council number :</p>
                <p>
                  {{
                    doctorInfo.userProfile.allied.council_registration_number
                      ? doctorInfo.userProfile.allied
                          .council_registration_number
                      : "&#8213;"
                  }}
                </p>
              </CCol>
            </CRow>
            <CRow>
              <CCol sm="6" md="3">
                <p class="text-dark mb-0">Qualifications to display :</p>
                <p
                  v-if="
                    doctorInfo.userProfile.allied.highest_qualification.length
                  "
                >
                  <span
                    v-for="(qualification, i) in doctorInfo.userProfile.allied
                      .highest_qualification"
                    :key="i"
                    >{{ qualification }}
                  </span>
                </p>
                <p v-else>&#8213;</p>
              </CCol>
              <CCol sm="6" md="3">
                <p class="text-dark mb-0">In practice since :</p>
                <p>
                  {{
                    doctorInfo.userProfile.allied.in_practice_since
                      ? doctorInfo.userProfile.allied.in_practice_since
                      : "&#8213;"
                  }}
                </p>
              </CCol>
              <CCol sm="6" md="3">
                <p class="text-dark mb-0">Year(s) of practice :</p>
                <p>
                  {{ doctorInfo.userProfile.allied.number_of_years_practicing }}
                  Years
                </p>
              </CCol>
              <CCol
                sm="6"
                md="3"
                @click="
                  doctorInfo.userProfile.allied.registration_proof_image_url
                    ? openModal(
                        doctorInfo.userProfile.allied
                          .registration_proof_image_url,
                        'Certificate'
                      )
                    : null
                "
              >
                <p class="text-dark mb-0">Certificate :</p>
                <div class="file-attachment d-flex align-items-center">
                  <fileSVG />
                  <p class="ml-2 mb-0 cursor">
                    {{
                      doctorInfo.userProfile.allied.registration_proof_image_url
                        ? doctorInfo.userProfile.allied.registration_proof_image_url
                            .split("/")
                            .pop()
                        : "&#8213;"
                    }}
                  </p>
                </div>
              </CCol>
              <CCol 
                sm="12"
                @click="
                  doctorInfo.userProfile.allied
                    .additional_registration_proof_image_url
                    ? openModal(
                        doctorInfo.userProfile.allied
                          .additional_registration_proof_image_url,
                        'Additional qualification certificate'
                      )
                    : null
                "
              >
                <p class="text-dark mb-0">
                  Additional qualification certificate :
                </p>
                <div v-if="doctorInfo.userProfile.allied
                    .additional_registration_proof_image_url" class="file-attachment d-flex align-items-center">
                  <fileSVG />
                  <p class="ml-2 mb-0 cursor">
                    {{
                      doctorInfo.userProfile.allied
                        .additional_registration_proof_image_url
                        ? doctorInfo.userProfile.allied.additional_registration_proof_image_url
                            .split("/")
                            .pop()
                        : "&#8213;"
                    }}
                  </p>
                </div>
              </CCol>
            </CRow>
            <CRow>
              <CCol sm="12" class="border-top">
                <h6 class="text-dark">Qualification (Optional)</h6>
              </CCol>
            </CRow>
            <CCol
              sm="12"
              v-if="doctorInfo.userProfile.allied.qualifications.length"
              class="border-all"
            >
              <CCol
                v-for="(qualification, i) in doctorInfo.userProfile.allied
                  .qualifications"
                :key="i"
                sm="12"
              >
                <CRow>
                  <CCol sm="12" class="pb-0 pl-0">
                    <h6>{{ qualification.education }}</h6>
                  </CCol>
                  <CCol
                    sm="12"
                    :class="{
                      'border-bottom': !(
                        i ===
                        doctorInfo.userProfile.allied.qualifications.length - 1
                      ),
                    }"
                    class="pt-0"
                  >
                    <CRow>
                      <CCol sm="6" md="1" class="pl-0">
                        <p class="text-dark mb-0">Year :</p>
                        <p>
                          {{
                            qualification.year ? qualification.year : "&#8213;"
                          }}
                        </p>
                      </CCol>
                      <CCol sm="6" md="4">
                        <p class="text-dark mb-0">College :</p>
                        <p>
                          {{
                            qualification.college_name
                              ? qualification.college_name
                              : "&#8213;"
                          }}
                        </p>
                      </CCol>
                      <CCol sm="6" md="3" class="sm-pl-0">
                        <p class="text-dark mb-0">University :</p>
                        <p>
                          {{
                            qualification.university_name
                              ? qualification.university_name
                              : "&#8213;"
                          }}
                        </p>
                      </CCol>
                      <CCol sm="6" md="2">
                        <p class="text-dark mb-0">State :</p>
                        <p>
                          {{
                            qualification.state
                              ? qualification.state
                              : "&#8213;"
                          }}
                        </p>
                      </CCol>
                      <CCol sm="6" md="2" class="sm-pl-0">
                        <p class="text-dark mb-0">Visibility :</p>
                        <p>{{ qualification.highest ? "Yes" : "No" }}</p>
                      </CCol>
                    </CRow>
                  </CCol>
                </CRow>
              </CCol>
            </CCol>
            <!-- ... -->
          </CCol>
        </CCol>
        <!-- ..... end Qualifications And Specialities ....... -->
        <!-- ...... clinic details ...... -->
        <CCol sm="12" class="p-0">
          <CCol sm="12" class="border-bottom">
            <h6 class="mb-0 text-dark">Clinic Details</h6>
          </CCol>

          <!-- ............ -->
          <CCol sm="12" class="border-bottom">
            <CCol
              v-if="!doctorInfo.doctor.data.centers_records.length"
              sm="12"
              class="p-0"
            >
              <p class="text-dark mb-0">I do not have a clinic</p>
              <p>
                {{
                  doctorInfo.userProfile.allied.do_not_has_clinic
                    ? "Yes"
                    : "&#8213;"
                }}
              </p>
            </CCol>

            <CCol
              v-for="(clinicDetail, i) in doctorInfo.doctor.data
                .centers_records"
              :key="i"
              sm="12"
              class="px-0"
            >
              <CRow>
                <CCol sm="6" md="3">
                  <p class="text-dark mb-0">Clinic Name :</p>
                  <p>{{ clinicDetail.general.name }}</p>
                </CCol>
                <CCol sm="6" md="4">
                  <p class="text-dark mb-0">
                    Show my personal number in prescription :
                  </p>
                  <p>
                    {{
                      clinicDetail.clinic.show_personal_number_in_prescription
                        ? "Yes"
                        : "No"
                    }}
                  </p>
                </CCol>
                <CCol sm="6" md="3">
                  <p class="text-dark mb-0">Clinic contact details :</p>
                  <p>
                    {{
                      clinicDetail.clinic.clinic_phone_number
                        ? clinicDetail.clinic.clinic_phone_number
                        : "&#8213;"
                    }}
                  </p>
                </CCol>
                <CCol sm="6" md="2">
                  <p class="text-dark mb-0">Fees first visit :</p>
                  <p>
                    <span
                      v-if="clinicDetail.clinic.fees_first_visit.currency_type"
                      >&#8377;</span
                    >
                    {{ clinicDetail.clinic.fees_first_visit.amount }}
                  </p>
                </CCol>
              </CRow>
              <CRow>
                <CCol sm="6" md="3">
                  <p class="text-dark mb-0">Fees Follow up :</p>
                  <p>
                    <span v-if="clinicDetail.clinic.fees_followup.currency_type"
                      >&#8377;</span
                    >
                    {{ clinicDetail.clinic.fees_followup.amount }}
                  </p>
                </CCol>
                <CCol sm="6" md="4">
                  <p class="text-dark mb-0">Address :</p>
                  <p v-if="clinicDetail.general.address">
                    {{
                      clinicDetail.general.address
                        ? clinicDetail.general.address.address_line_two
                        : "&#8213;"
                    }}
                  </p>
                </CCol>
                <CCol sm="6" md="3">
                  <p class="text-dark mb-0">More details :</p>
                  <p>
                    {{
                      clinicDetail.clinic.appointment_duration
                        ? clinicDetail.clinic.appointment_duration
                        : "&#8213;"
                    }}
                  </p>
                </CCol>
                <CCol sm="6" md="2">
                  <p class="text-dark mb-0">Appointment duration :</p>
                  <p>
                    {{
                      clinicDetail.clinic.appointment_duration
                        ? clinicDetail.clinic.appointment_duration
                        : "&#8213;"
                    }}
                    minutes
                  </p>
                </CCol>
              </CRow>
              <CRow>
                <CCol sm="12" class="pb-0">
                  <h6 class="text-dark mb-0">Timing</h6>
                </CCol>
                <CCol
                  v-for="(timing, j) in clinicDetail.clinic.timings"
                  :key="j"
                  sm="6"
                  md="3"
                >
                  <p class="text-dark mb-0">{{ timing.day }}</p>
                  <p
                    v-for="(t, timingIndex) in timing.time_open"
                    :key="timingIndex"
                  >
                    {{ timing.time_open[timingIndex] }} to
                    {{ timing.time_close[timingIndex] }}
                  </p>
                </CCol>
                <!-- <CCol sm="3">
                  <p class="text-dark mb-0">Saturday :</p>
                  <p>10.00 AM to 3.00 PM</p>
                </CCol>
                <CCol sm="3">
                  <p class="text-dark mb-0">Sunday :</p>
                  <p>11.00 AM to 4.00 PM</p>
                </CCol>-->
              </CRow>
              <hr
                v-if="
                  !(doctorInfo.doctor.data.centers_records.length - 1 === i)
                "
              />
            </CCol>
          </CCol>
        </CCol>
        <!-- ...... end clinic details ...... -->
        <!-- ...... Additional Details ...... -->
        <CCol sm="12" class="p-0">
          <CCol sm="12" class="border-bottom">
            <h6 class="mb-0 text-dark">Additional Details</h6>
          </CCol>
          <CCol sm="12" class="border-bottom">
            <CRow>
              <CCol sm="6" md="4">
                <p class="text-dark mb-0">
                  Online consultation : 
                </p>
                <p class="mb-0">
                  {{
                    doctorInfo.userProfile.allied.online_consultation
                      .is_video_oc_included
                      ? "Include Video Consultation (30 mins)"
                      : "&#8213;"
                  }}
                </p>
                <p>
                  <span>
                    {{
                      doctorInfo.userProfile.allied.online_consultation
                        .is_participating
                        ? "Yes"
                        : "No"
                    }}
                  </span>
                  Fees &#8377;
                  {{
                    doctorInfo.userProfile.allied.online_consultation
                      .base_charges
                  }}
                </p>
              </CCol>
              <CCol sm="6" md="4">
                <p class="text-dark mb-0">Home visit : </p>
                <p v-if="doctorInfo.userProfile.allied.home_visit">
                  {{
                    doctorInfo.userProfile.allied.home_visit
                      .is_available_for_home_visit
                      ? "Yes"
                      : "No"
                  }}
                  <span
                    v-if="
                      doctorInfo.userProfile.allied.home_visit
                        .is_available_for_home_visit
                    "
                  >
                    {{
                      `Fees : ${doctorInfo.userProfile.allied.home_visit.home_visit_charges}`
                    }}
                  </span>
                </p>
              </CCol>
              <CCol sm="6" md="4">
                <p class="text-dark mb-0">
                  Free consultation :
                </p>
                <p>
                  {{
                    doctorInfo.userProfile.allied
                      .is_available_for_free_consultation
                      ? "Yes"
                      : "No"
                  }}
                </p>
              </CCol>
            </CRow>
            <CRow>
              <CCol sm="6" md="4">
                <p class="text-dark mb-0">
                  Participating in the forum for Second Opinion of Docsmart?
                </p>
                <p>
                  {{
                    doctorInfo.userProfile.allied
                      .is_intrested_part_of_second_opinion_panel
                      ? "Yes"
                      : "No"
                  }}
                </p>
              </CCol>
              <CCol sm="6" md="4">
                <p class="text-dark mb-0">
                  Part of "Panel Of Experts" on Docsmart?
                </p>
                <p>
                  {{
                    doctorInfo.userProfile.allied
                      .is_intrested_part_of_panel_of_experts
                      ? "Yes"
                      : "No"
                  }}
                </p>
              </CCol>
              <CCol sm="6" md="4">
                <p class="text-dark mb-0">
                  Interested to be part of Medico Legal Panel of Docsmart
                </p>
                <p>
                  {{
                    doctorInfo.userProfile.allied
                      .is_intrested_part_of_medico_legal_panel
                      ? "Yes"
                      : "No"
                  }}
                </p>
              </CCol>
            </CRow>
            <CRow>
              <CCol sm="6" md="4">
                <p class="text-dark mb-0">
                  Part of any Government Policy Panel :
                </p>
                <p>
                  {{
                    doctorInfo.userProfile.allied.is_part_of_govt_policy_panel
                      ? "Yes"
                      : "No"
                  }}
                </p>
              </CCol>
              <CCol sm="6" md="4">
                <p class="text-dark mb-0">
                  Part of any Insurance Company Policy Panel : 
                </p>
                <p>
                  {{
                    doctorInfo.userProfile.allied
                      .is_part_of_insurance_company_policy_panel
                      ? "Yes"
                      : "No"
                  }}
                </p>
              </CCol>
            </CRow>
          </CCol>
        </CCol>
        <!-- ...... end Additional Details ...... -->
        <!-- ...... Medical Association Membership ...... -->
        <!-- <CCol sm="12" class="p-0">
          <CCol sm="12" class="border-bottom">
            <h6 class="mb-0 text-dark">Medical Association Membership</h6>
          </CCol>
          <CCol sm="12" class="border-bottom">
            <CRow v-if="doctorInfo.userProfile.association_memberships.length">
              <CRow v-for="(associationMemberships, index) in doctorInfo.userProfile
                    .association_memberships" :key="index" class="pa-3" style="width: 100% !important">
                <CCol sm="6" md="3">
                  <p class="text-dark mb-0">Association Name :</p>
                  <p>
                    {{
                      associationMemberships.association_name
                      ? associationMemberships.association_name
                      : "&#8213;"
                    }}
                  </p>
                </CCol>
                <CCol sm="6" md="3">
                  <p class="text-dark mb-0">Branch of Association :</p>
                  <p>
                    {{
                      associationMemberships.branch
                      ? associationMemberships.branch
                      : "&#8213;"
                    }}
                  </p>
                </CCol>
                <CCol sm="6" md="3" @click="associationMemberships.id_url
                      ? openModal(
                        associationMemberships.id_url,
                        'Assotiation Membership Identity'
                      )
                      : null
                    ">
                  <p class="text-dark mb-0">Id :</p>
                  <div class="file-attachment d-flex align-items-center">
                    <fileSVG />
                    <p class="ml-2 mb-0 cursor">
                      {{
                        associationMemberships.id_url
                        ? associationMemberships.id_url.split("/").pop()
                        : "&#8213;"
                      }}
                    </p>
                  </div>
                </CCol>
                <CCol sm="6" md="3">
                  <p class="text-dark mb-0">Existing Post :</p>
                  <p>
                    {{
                      associationMemberships.post
                      ? associationMemberships.post
                      : "&#8213;"
                    }}
                  </p>
                </CCol>
              </CRow>

              <CCol sm="12" class="border-bottom border-top">
                <h6 class="mb-0 text-dark">Corporate and Government Bodies</h6>
              </CCol>
              <CCol v-if="doctorInfo.userProfile.association_bodies.length">
                <CCol v-for="(associationBodies, idx) in doctorInfo.userProfile
                      .association_bodies" :key="idx" sm="12">
                  <CRow>
                    <CCol sm="6" md="3">
                      <p class="text-dark mb-0">Type :</p>
                      <p>
                        {{
                          associationBodies.assoc_type
                          ? associationBodies.assoc_type
                          : "&#8213;"
                        }}
                      </p>
                    </CCol>
                    <CCol sm="6" md="3">
                      <p class="text-dark mb-0">Name :</p>
                      <p>
                        {{
                          associationBodies.name
                          ? associationBodies.name
                          : "&#8213;"
                        }}
                      </p>
                    </CCol>
                    <CCol sm="6" md="3">
                      <p class="text-dark mb-0">Department :</p>
                      <p>
                        {{
                          associationBodies.department
                          ? associationBodies.department
                          : "&#8213;"
                        }}
                      </p>
                    </CCol>
                    <CCol sm="6" md="3">
                      <p class="text-dark mb-0">Designation :</p>
                      <p>
                        {{
                          associationBodies.designation
                          ? associationBodies.designation
                          : "&#8213;"
                        }}
                      </p>
                    </CCol>
                  </CRow>
                  <CRow>
                    <CCol sm="6" md="3">
                      <p class="text-dark mb-0">From Date :</p>
                      <p>
                        {{
                          associationBodies.since
                          ? dayJS(associationBodies.since).format(
                            formats.date_format
                          )
                          : "&#8213;"
                        }}
                      </p>
                    </CCol>
                    <CCol sm="6" md="3">
                      <p class="text-dark mb-0">Working Currently :</p>
                      <p>
                        {{
                          associationBodies.is_working_currently ? "Yes" : "No"
                        }}
                      </p>
                    </CCol>
                    <CCol sm="6" md="3">
                      <p class="text-dark mb-0">To Date :</p>
                      <p>
                        {{
                          associationBodies.till
                          ? dayJS(associationBodies.till).format(
                            formats.date_format
                          )
                          : "&#8213;"
                        }}
                      </p>
                    </CCol>
                  </CRow>
                  <hr v-if="!(
                        idx ===
                        doctorInfo.userProfile.association_bodies.length - 1
                      )
                      " />
                </CCol>
              </CCol>
              <CCol v-else>
                <div>No Data Found</div>
              </CCol>
            </CRow>
            <CRow v-else>
              <CCol sm="12">No Data Found</CCol>
            </CRow>
          </CCol>
        </CCol> -->
        <!-- ...... end Medical Association Membership ...... -->
      </CCol>
    </CCol>
    <image-preview
      @close="closeImageModal"
      v-if="openImageModal"
      :openImageModal="openImageModal"
      :source="fileUrl"
      :fileArcheType="fileArcheType"
    ></image-preview>
  </div>
</template>
<script>
import config from "@/config.js";
import { pickSvg } from "@/views/SVG";
const Image = () => import("@/components/image.vue");
const LightBoxNew = () => import("@/components/lightBoxNew.vue");
const imagePreview = () => import("@/components/modals/imagePreview.vue");
const loader = () => import("@/components/loader.vue");
import "@/assets/scss/_userDetails.scss";
const dayJS = require("@/methods/dayjs")
  .advancedFormat()
  .customParseFormat()
  .build();
import formats from "@/formats";
export default {
  props: ["userId"],
  components: {
    "light-box-new": LightBoxNew,
    "image-view": Image,
    "image-preview": imagePreview,
    ...pickSvg("crossSVG", "fileSVG"),
    loader,
  },
  created() {
    this.getDoctorDetails();
  },

  data() {
    return {
      openImageModal: false,
      dayJS,
      formats,
      doctorInfo: {},
      isEmpty: true,
      fileUrl: "",
      fileArcheType: "",
    };
  },
  methods: {
    closeImageModal() {
      this.openImageModal = false;
    },
    openModal(fileUrl, fileArcheType) {
      this.fileUrl = fileUrl;
      this.fileArcheType = fileArcheType;
      this.openImageModal = true;
    },
    getDoctorDetails() {
      this.$store.commit("general/setLoader", true);
      let role = "allied";
      let url = `${config.BASE_URL}api/v2/admin/users/${this.userId}/profile?role=${role}`;
      this.$http.get(url).then((response) => {
        if (response.body.status) {
          this.$store.commit("general/setLoader", false);
          this.doctorInfo = response && response.body && response.body.data;
          this.isEmpty = false;
        } else {
          this.$store.commit("general/setLoader", false);
          this.isEmpty = true;
        }
      });
    },
  },
};
</script>
